<template>
  <div class="plantilla-detail">
    <div>
      <p class="mb-0 text-break">
        {{ plantilla.name }}
      </p>
      <p class="mb-0 text-break">
        {{ plantilla.content }}
      </p>
    </div>
    <div class="d-align-center-nowrap">
      <div
        class="plantilla-status"
        title="Estatus"
      >
        {{ plantilla.status }}
      </div>
      <slot name="botones" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Plantilla',
  props: {
    plantilla: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss">
  .plantilla-list {
    list-style: none;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    @media(min-width: 576px) {
      flex-flow: row wrap;
      justify-content: space-between;
    }

    li {
      align-self: center;
      display: flex;
      margin: .25rem .5rem;
      padding: .25rem .5rem;
      width: 100%;

      @media (min-width: 992px) {
        width: 45%;
      }
    }

    .plantilla-detail {
      align-items: center;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      width: 100%;

      .btn-flat {
        padding: .25rem;
      }
      .btn-flat.danger-text {
        color: #ff4444;
        &:hover {
          color: #CC0000;
        }
      }
    }
    .d-align-center-nowrap {
      align-items: center;
      display: flex;
      flex-flow: row nowrap;
    }
    .plantilla-status {
      color: #212121;
      cursor: default;
      font-size: .65rem;
      font-weight: 600;
      margin-left: 0.5rem;
    }
  }
</style>
